import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import Layout from '@shared/components/layout'
import queryGraphql from '@shared/components/queryGraphql'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { pageLoading } from '@shared/libs/allLoader'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { handleApiError } from '@shared-submodule/utils'
import { CATEGORY_RELATED_VIDEO, GET_SINGLE_VIDEO } from '@graphql/cricket-video/cricket-video.query'
const VideoDetails = dynamic(() => import('@shared/components/video/videoDetails'), { loading: () => pageLoading() })

const CricketVideos = ({ video, data, seoData }) => {
  const videoList = data?.listCategoryRelatedVideos?.aResults
  const videoData = video

  return (
    <Layout data={{ oSeo: seoData }}>
      <VideoDetails videoData={videoData} videoList={videoList} />
    </Layout>
  )
}

CricketVideos.propTypes = {
  data: PropTypes.object,
  video: PropTypes.object,
  seoData: PropTypes.object
}

export async function getServerSideProps({ res, params, resolvedUrl }) {
  const slug = params.slug
  const mSlug = allRoutes.cricketVideo + '/' + slug.join('/')
  try {
    const { checkRedirectionStatus } = (await import('@shared-submodule/utils'))
    res.setHeader('Cache-Control', 'public, max-age=420')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: mSlug } })

    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    const { data: video } = await queryGraphql(GET_SINGLE_VIDEO, { input: { _id: seoData?.getSeoData?.iId } })

    if (seoData?.getSeoData?.sTitle.includes('Brand Ambassador')) {
      return {
        props: {
          video: video?.getSingleVideo,
          seoData: seoData?.getSeoData
        }
      }
    } else {
      const { data } = await queryGraphql(CATEGORY_RELATED_VIDEO, {
        input: { _id: seoData?.getSeoData?.iId, oGetVideosPaginationInput: { nLimit: 10, nSkip: 0 } }
      })
      return {
        props: {
          data,
          video: video?.getSingleVideo,
          seoData: seoData?.getSeoData
        }
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

export default CricketVideos
